// extracted by mini-css-extract-plugin
export default {"root":"Content_root__JAGc0"};